var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo/C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emprunteur",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parcours-MONOEMP-2---1-(v2)",
    transform: "translate(-6.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo/C",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cetelem_LogoSign_Quad",
    transform: "translate(12.000000, 6.000000)",
    fill: "#3A913F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4621295,26.8116094 C7.37238998,26.8152337 2.03967171,22.7419485 0.461070068,16.8810078 C-1.11753158,11.0200672 1.45173003,4.83335078 6.72487797,1.79791825 C11.9980259,-1.23751427 18.6597921,-0.36454263 22.9661295,3.92620549 C23.8249418,4.95242886 23.7564939,6.46196853 22.8083055,7.40682999 C21.860117,8.35169145 20.3452621,8.41989922 19.3154252,7.56410022 C17.7644683,6.02240745 15.6620756,5.15837826 13.4714055,5.16235869 C11.2807353,5.16633912 9.18151865,6.03800261 7.63621397,7.58532128 C5.5461197,9.66483265 4.72810541,12.69752 5.49030919,15.5409992 C6.25251296,18.3844785 8.4791379,20.6067577 11.3314359,21.3707256 C14.183734,22.1346935 17.2283732,21.3242853 19.3184675,19.2447739 C19.9515086,18.5096131 20.9444772,18.1897885 21.8895619,18.4166517 C22.8346466,18.643515 23.5725477,19.378827 23.8002098,20.3205956 C24.0278719,21.2623643 23.7069211,22.2518488 22.9691717,22.8826686 C20.4522371,25.4025143 17.0299508,26.8168249 13.4621295,26.8116094 L13.4621295,26.8116094 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8374534,35.5001002 L3.98550975,35.5001002 C2.71547696,35.4546467 1.70945474,34.4155033 1.70945474,33.1491107 C1.70945474,31.8827182 2.71547696,30.8435748 3.98550975,30.7981213 L21.8374534,30.7981213 C23.1074862,30.8435748 24.1135084,31.8827182 24.1135084,33.1491107 C24.1135084,34.4155033 23.1074862,35.4546467 21.8374534,35.5001002 L21.8374534,35.5001002 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/cLogo.e6eb91b10e18030f418f107f0be04764.svg";
export { ForwardRef as ReactComponent };